export function disableLink(element: HTMLElement) {
  element.classList.add("secure-disabled"), (element.tabIndex = -1);
}
